<template>
  <div>
    <el-form
      ref="studentPerformance"
      label-position="top"
      :model="studentPerformance"
      :hide-required-asterisk ='true'
       :rules="rules"
      label-width="80px"
    >
      <formTitle title="學生表現 Student Performance"></formTitle>
      <div class="row-list">
        <el-row type="flex" align="middle">
          <el-col :xl="12" :xs="24">
            <div class="plain-button-title">
              學術及非學術表現 Academic and Non-Academic Performance
            </div>
          </el-col>
        </el-row>
        <div class="student-list-title" v-for="(item,index) in studentPerformance.studentPerformances" :key="index"> 
          <el-form-item label="年级 Level">
                <el-input
                  :disabled="true"
                  v-model="item.level"
                ></el-input>
          </el-form-item>
          <div v-for="(items,indexs) in item.terms" :key="indexs">
            <div><span class="star-mark" v-if="items.levelTitle == 'Term 1' || items.levelTitle == 'Term 2'"> *</span> {{items.levelTitle}}</div>
            <el-row :gutter="20" type="flex" align="middle"> 
              <el-col :span="4" style="margin-top: -38px;">Grade/Marks:</el-col>
              <el-col :span="20"> 
                <el-row :gutter="20" type="flex">
                  <el-col :span="6">
                    <el-form-item label="中文 Chinese Language" :prop="'studentPerformances.' + index+ '.terms.' + indexs + '.chineseLanguage'" :rules="[

                      { required: items.levelTitle == 'Term 1' || items.levelTitle == 'Term 2', message: 'Please input the Chinese Language', trigger: 'change' },
                    
                    ]">
                      <el-input
                        :disabled="isView"
                        v-model="items.chineseLanguage"
                      ></el-input>
                      
                    </el-form-item>
                    <p>(e.g.A, 95/100, 245/300, Meeting Expectations or NA 以示不適用)</p>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="英文 English Language" :prop="'studentPerformances.' + index+ '.terms.' + indexs + '.englishLanguage'" :rules="[

                      { required: items.levelTitle == 'Term 1' || items.levelTitle == 'Term 2', message: 'Please input the English Language', trigger: 'change' },
                    
                    ]">
                      <el-input
                        :disabled="isView"
                        v-model="
                          items.englishLanguage
                        "
                      ></el-input>
                      
                    </el-form-item>
                    <p>(e.g.A, 95/100, 245/300, Meeting Expectations or NA 以示不適用)</p>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="數學 Mathematics" :prop="'studentPerformances.' + index+ '.terms.' + indexs + '.mathematics'" :rules="[

                      { required: items.levelTitle == 'Term 1' || items.levelTitle == 'Term 2', message: 'Please input the Mathematics', trigger: 'change' },
                    
                    ]">
                      <el-input
                        :disabled="isView"
                        v-model="
                          items.mathematics
                        "
                      ></el-input>
                      
                    </el-form-item>
                    <p>(e.g.A, 95/100, 245/300, Meeting Expectations or NA 以示不適用)</p>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="操行 Conduct" :prop="'studentPerformances.' + index+ '.terms.' + indexs + '.conduct'" :rules="[

                      { required: items.levelTitle == 'Term 1' || items.levelTitle == 'Term 2', message: 'Please input the Conduct', trigger: 'change' },
                    
                    ]">
                      <el-input
                        :disabled="isView"
                        v-model="
                          items.conduct
                        "
                      ></el-input>
                      
                    </el-form-item>
                    <p>(e.g.A, 95/100, 245/300, Meeting Expectations or NA 以示不適用)</p>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getEventStatusDetail } from "@/api/parent/eventStatus";
import formTitle from "@/components/formTitle";
export default {
  components: { formTitle },
  props: {
    applicationDetail: {
      type: Object,
      default: function () {},
    },
    studentPerformance: {
      type: Object,
      default: function () {},
    },
    isView: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    eventStatusId: {
      type: Number,
      default: 0,
    }
  },
  computed: {
    stage() {
      return this.$store.getters.stage;
    },
  },
  data() {
    return {
      eventStatusDetail: {},
      rules:{}
    };
  },
  watch:{
    'applicationDetail':{
      handler: function (val) {
        if(val){
          let isLevel = this.studentPerformance.studentPerformances.every(item => item.level == '')
          if(this.eventStatusId ==0 &&isLevel){
            this.$set(this.studentPerformance.studentPerformances[0],'level',this.applicationDetail?.eventStatus.level1)
            this.$set(this.studentPerformance.studentPerformances[1],'level',this.applicationDetail?.eventStatus.level2)
            this.$set(this.studentPerformance.studentPerformances[2],'level',this.applicationDetail?.eventStatus.level3)
          }
        }
      },
      deep: true,
      immediate:true
    },
    'studentPerformance.studentPerformances.length':{
      handler: function (val) {
        if(val > 0){
          if((this.isView == false) && this.stage == 2 && this.eventStatusId !=0 ){
              this.getEventStatusDetail()
          }
        }
      },
      deep: true,
      immediate:true
    }
  },
  created(){
    if(this.studentPerformance.studentPerformances.length == 0){
      this.initialization()
    }
  },
  methods: {
    initialization(){
      this.studentPerformance.studentPerformances = []
      for (let i = 0; i < 3; i++) {
        this.studentPerformance.studentPerformances.push({
              level: '',
              terms: [
                {
                  chineseLanguage: "",
                  englishLanguage: "",
                  mathematics: "",
                  conduct: "",
                  levelTitle:'Term 1',
                },
                {
                  chineseLanguage: "",
                  englishLanguage: "",
                  mathematics: "",
                  conduct: "",
                  levelTitle:'Term 2',
                },
                {
                  chineseLanguage: "",
                  englishLanguage: "",
                  mathematics: "",
                  conduct: "",
                  levelTitle:'Term 3 (if applicable)',
                },
                {
                  chineseLanguage: "",
                  englishLanguage: "",
                  mathematics: "",
                  conduct: "",
                  levelTitle:'Term 4 (if applicable)',
                },
                {
                  chineseLanguage: "",
                  englishLanguage: "",
                  mathematics: "",
                  conduct: "",
                  levelTitle:'Overall (if applicable)',
                },

              ]
          });
      }
    },
    getEventStatusDetail(){
      getEventStatusDetail(this.eventStatusId).then((v)=>{
          this.eventStatusDetail = v.data
          this.$set(this.studentPerformance.studentPerformances[0],'level',this.eventStatusDetail.level1)
          this.$set(this.studentPerformance.studentPerformances[1],'level',this.eventStatusDetail.level2)
          this.$set(this.studentPerformance.studentPerformances[2],'level',this.eventStatusDetail.level3)
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.document-identity-radio {
  display: flex;
  flex-direction: column;
}
.document-identity-radio .el-radio {
  display: flex;
  margin-bottom: 20px;
}
.el-button--primary {
  width: auto;
}
.row-list {
  padding: 30px 0;
}
.from-button-group {
  margin-top: 30px;
}
.student-list-title{
  padding: 30px 0;
  border-bottom: 1px solid #e5e5e5;
}
p{
  color: #C0C4CC;
}
.star-mark {
  color: red;
  font-size: 16px;

}
::v-deep {
  .el-input__inner {
    border-color: #72acff;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  ::v-deep {
    .el-form-item__label {
      line-height: 1.25rem;
    }
  }
}
</style>